import React from "react";
import get from "lodash/get";
import { object, array, bool, string } from "prop-types";
import assetify from "@quintype/framework/assetify";
import { ResponsiveImage, Link } from "@quintype/components";

import DefaultAuthorImage from "../../../../assets/images/default-author-image.svg";

import "./contributorImage.m.css";

// eslint-disable-next-line react/prop-types
const ContributorImage = ({
  authorDisplayName = "",
  authorObj = {},
  slug = "",
  customStyle = false,
  blurStyle = false,
  widths = [100],
  memberProfilePic = false,
}) => {
  const authorImg = authorObj ? authorObj["avatar-s3-key"] || authorObj["avatar-url"] : null;
  const publicAuthor = get(authorObj, "metadata['Public Author']", "No").toLowerCase() === "yes";
  const customWrapperStyle = customStyle ? "contributor-base-wrapper-custom" : "";
  const blurImageStyle = blurStyle ? "contributor-image-blur contributor-image" : "contributor-image";

  const noAuthorImage = () => {
    return publicAuthor ? (
      <Link href={slug}>
        <img
          styleName={blurImageStyle}
          className="contributor-image"
          src={`${assetify(DefaultAuthorImage)}`}
          alt={authorObj.name}
        />
      </Link>
    ) : (
      <img
        styleName={blurImageStyle}
        className="contributor-image"
        src={`${assetify(DefaultAuthorImage)}`}
        alt={authorObj.name}
      />
    );
  };

  const s3AuthorImage = () => {
    return publicAuthor ? (
      <Link href={slug}>
        <ResponsiveImage
          slug={authorObj["avatar-s3-key"]}
          metadata={authorObj.metadata || ""}
          aspectRatio={[1, 1]}
          defaultWidth={100}
          widths={widths}
          imgParams={{ auto: ["format", "compress"] }}
          styleName={blurImageStyle}
          className="contributor-image"
          alt={authorObj.name}
        />
      </Link>
    ) : (
      <ResponsiveImage
        slug={authorObj["avatar-s3-key"]}
        metadata={authorObj.metadata || ""}
        aspectRatio={[1, 1]}
        defaultWidth={100}
        widths={widths}
        imgParams={{ auto: ["format", "compress"] }}
        styleName={blurImageStyle}
        className="contributor-image"
        alt={authorObj.name}
      />
    );
  };

  const avatarAuthorImage = () => {
    return publicAuthor ? (
      <Link href={slug}>
        <img
          styleName={blurImageStyle}
          className="contributor-image"
          src={authorObj["avatar-url"]}
          alt={authorObj.name}
        />
      </Link>
    ) : (
      <img
        styleName={blurImageStyle}
        className="contributor-image"
        src={authorObj["avatar-url"]}
        alt={authorObj.name}
      />
    );
  };

  const imageShow = () => {
    const isShowImage = (!authorDisplayName && authorImg && publicAuthor) || memberProfilePic;
    return isShowImage ? (authorObj["avatar-s3-key"] ? s3AuthorImage() : avatarAuthorImage()) : noAuthorImage();
  };

  return (
    <div className="contributor-base-wrapper" styleName={customWrapperStyle}>
      {imageShow()}
    </div>
  );
};

ContributorImage.propTypes = {
  authorObj: object,
  widths: array,
  authorDisplayName: string,
  slug: string,
  customStyle: bool,
  blurStyle: bool,
  memberProfilePic: bool,
};

export default ContributorImage;
